/**
 * Enumeration of macro permissions for the bancassurance application
 */
export enum MacroPermission {
  CreatePolice = 'CreatePolice',
  ValidatePolice = 'ValidatePolice',
  VisualizePolice = 'VisualizePolice',
  BatchTransfert = 'BatchTransfert',
  BatchVisualize = 'BatchVisualize',
  ManageUser = 'ManageUser',
  ManageGroupContract = 'ManageGroupContract',
  ManageProduct = 'ManageProduct',
  ManageTemplate = 'ManageTemplate',
  ManageHealthQuestion = 'ManageHealthQuestion',
  ManageCity = 'ManageCity',
  ManagerVisualizePolice = 'ManagerVisualizePolice',
  ClaimVisualize= 'ClaimVisualize',
  CreateClaims= 'CreateClaims',
  ReadGroupcontractappetizerrate= 'ReadGroupcontractappetizerrate',
  ReadOnlyCoEnssurance= 'ReadOnlyCoEnssurance',
  ReadOnlyCommission= 'ReadOnlyCommission',
}

/**
 * Array of all available macro permissions
 */
export const ALL_MACRO_PERMISSIONS: MacroPermission[] = [
  MacroPermission.CreatePolice,
  MacroPermission.ValidatePolice,
  MacroPermission.VisualizePolice,
  MacroPermission.BatchTransfert,
  MacroPermission.BatchVisualize,
  MacroPermission.ManageUser,
  MacroPermission.ManageGroupContract,
  MacroPermission.ManageProduct,
  MacroPermission.ManageTemplate,
  MacroPermission.ManageHealthQuestion,
  MacroPermission.ManageCity,
  MacroPermission.CreateClaims,
  MacroPermission.ClaimVisualize,
  MacroPermission.ReadGroupcontractappetizerrate,
  MacroPermission.ReadOnlyCoEnssurance,
  MacroPermission.ReadOnlyCommission,
];

/**
 * Type guard to check if a string is a valid macro permission
 */
export function isMacroPermission(value: string): value is MacroPermission {
  return Object.values(MacroPermission).includes(value as MacroPermission);
}
